import React from "react";
import assetsManager from "../assets/assetsmanager/assestsmanager";

const Pagination = ({ data, page, handleChangePage, rowsPerPage }) => {
  return (
    <div className="table-pagination flex justify-end items-center h-[1.8rem] gap-2">
      <div className="text-sm min-w-[8rem]">
        Page{" "}
        <input
          className=" border-[2px] py-0.5 px-[0.55rem] rounded-[3px] mx-[0.2rem] border-[--primary]"
          type="number"
          min={"1"}
          max={Math.ceil(data?.length / rowsPerPage)}
          value={page + 1}
          disabled
        />{" "}
        of {Math.ceil(data.length / rowsPerPage)}
      </div>
      <div className="flex h-[85%] full rounded-1 overflow-hidden bg-[#C7222A] rounded-[4px]">
        <button
          className="h-full px-2 py-1 rounded-[4px] bg-[#C7222A] border-none flex items-center justify-center "
          disabled={page === 0}
          onClick={() => handleChangePage(page - 1)}
          aria-label="Previous Page"
        >
          <img src={assetsManager.prevArrow} alt="" />
        </button>
        <button
          className="h-full px-2 py-1 rounded-[4px] bg-[--primary] border-none flex items-center justify-center"
          disabled={page >= Math.ceil(data?.length / rowsPerPage) - 1}
          onClick={() => handleChangePage(page + 1)}
          aria-label="Next Page"
        >
          <img src={assetsManager.nextArrow} alt="" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
